/**
 * Enum for stati-pratica.
 * @readonly
 * @enum {{stato: string}}
 */
export const StatiPratica = Object.freeze({
  IN_LAVORAZIONE: { stato: 'In Lavorazione' },
  CHECK_OUT_OPERATORE: { stato: 'Check Out Operatore' },
  CHIUSA: { stato: 'Chiusa' },
  DA_APPROVARE: { stato: 'Da Approvare' },
  IN_RICHIESTA: { stato: 'In Richiesta' },
  IN_ATTESA_OPZIONALI: { stato: 'In Attesa Opzionali' },
  INFO_COMPLETE: { stato: 'Info Complete' },
  ANNULLATA: { stato: 'Annullata' },
})
